import { render, staticRenderFns } from "./image-lightbox.vue?vue&type=template&id=00765b44&scoped=true"
import script from "./image-lightbox.vue?vue&type=script&lang=js"
export * from "./image-lightbox.vue?vue&type=script&lang=js"
import style0 from "./image-lightbox.vue?vue&type=style&index=0&id=00765b44&prod&scoped=true&lang=css"
import style1 from "./image-lightbox.vue?vue&type=style&index=1&id=00765b44&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00765b44",
  null
  
)

export default component.exports